import React, { useCallback, useMemo, useState } from 'react'
import { submitReportProgress } from '@/enums/submitReportProgress'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'
import context from '@/context'
import { SimpleCard } from '@/report-app/pages/reporting/submissions/submit/simpleCard'

function StartSubmissionCard ({ reportInstanceGroupId, submitProgress, onSubmitProgressChange, onStopSubmission, hasRunningBgJobs }) {
  const [startSubmitFailed, setStartSubmitFailed] = useState(false)

  const cardColor = useMemo(() => startSubmitFailed ? 'danger' : '', [startSubmitFailed])
  const icon = useMemo(() => startSubmitFailed ? 'bx-error' : '', [startSubmitFailed])

  const startSubmission = useCallback(() =>
    context.api.reportSubmissionGroupService.startSigning(reportInstanceGroupId)
      .then(() => onSubmitProgressChange(submitReportProgress.enum.Started))
      .catch(() => setStartSubmitFailed(true)), [onSubmitProgressChange, reportInstanceGroupId])

  const renderFinishedMessage = useCallback(() => <React.Fragment>
    <Resx name='Reporting.SubmissionStartedText' />
    <br />
    {!hasRunningBgJobs && <Button icon='bx-trash' color='danger' onClick={onStopSubmission}
      confirmTitle='Reporting.InterruptSubmission'
      confirmText='Reporting.InterruptSubmissionText'>
      <Resx name='Reporting.InterruptSubmission' />
    </Button>}
  </React.Fragment>, [onStopSubmission, hasRunningBgJobs])

  return <SimpleCard cardColor={cardColor}
    icon={icon}
    submitProgress={submitProgress}
    beforeStartText=''
    headerText='Reporting.BeginSubmission'
    renderFinishedMessage={renderFinishedMessage}
    activateSubmitProgress={submitReportProgress.enum.NotStarted}
    dataCy='startSubmissionCard' >
    <Button icon='bx-send' color='primary'
      confirmTitle='Reporting.StartSubmission'
      confirmText='Reporting.StartSubmissionText'
      onClick={startSubmission}>
      <Resx name='Reporting.StartSubmission' />
    </Button>
  </SimpleCard>
}

export { StartSubmissionCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/startSubmissionCard.js